import { Nav } from '@/components/nav/nav';
import { Button } from '@streetferret/ui-web/button';
import { Container } from '@streetferret/ui-web/container';
import Link from 'next/link';
import { DonateButton } from '@streetferret/ui-web/button';
import { SideNav } from './side-nav';
import { NavLink, TopNav } from './top-nav';

export function NavBar() {
  return (
    <Nav className="overflow-hidden">
      <Container>
        <div className="flex items-center justify-between -ml-4 -mr-3">
          <Button
            variant={'ghost'}
            className="text-lg dark:text-white !font-bold"
            asChild>
            <Link href="/">
              <div>
                <div className="leading-none">Paul Johnson</div>
                <div className="text-[7px] leading-3 text-muted-foreground">
                  Powered by StreetFerret
                </div>
              </div>
            </Link>
          </Button>
          <div className="flex items-center gap-2">
            <NavLink segment="track" />
            <TopNav />
            <DonateButton />
            <SideNav />
          </div>
        </div>
      </Container>
    </Nav>
  );
}
